<!-- =========================================================================================
  File Name: TicketEditTabInfo.vue
  Description: Ticket Edit Tab Info page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.auth-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.button-wrap {
  text-align: right;
  margin-top: 20px;
}

.vs-con-textarea {
  margin-bottom: 0px;
}
.domain-wrapper {
}
.domain-name {
  margin-left: 10px;
}
.single-color-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
#ticket-edit-tab-info {
  width: 800px;
}
</style>
<template>
  <div id="ticket-edit-tab-info">
    <!-- <h3 class="my-5">Ticket Details</h3> -->

    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full">
        <label>Registration Type</label>
        <vs-input
          class="w-full"
          name="RegistrationType"
          v-validate="'required'"
          v-model="data_local.RegistrationType"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('RegistrationType')"
          >{{ errors.first("RegistrationType") }}</span
        >
      </div>
      <div class="vx-col sm:w-4/12 w-full mt-4">
        <div class="domain-wrapper">
          <label>Color Code</label>
          <div class="flex justify-start items-center">
            <vs-input
              class="w-full"
              name="ColorCode"
              v-model="data_local.ColorCode"
            />
            <input
              class="ml-1"
              style="height: 40px; width: 40px"
              type="color"
              v-model="data_local.ColorCode"
            />
          </div>
        </div>
      </div>
      <div class="vx-col sm:w-4/12 w-full mt-10">
        <div class="domain-wrapper flex justify-between items-center">
          <label>Quantity</label>
          <div class="ticket-quantity-wrap">
            <vs-input-number
              class="w-full"
              :min="1"
              :max="100000"
              name="Quantity"
              v-model="data_local.Quantity"
              v-validate="'required' | 'number' | 'max_value:100000'"
            />
          </div>
        </div>
        <span class="text-danger text-sm" v-show="errors.has('Quantity')">{{
          errors.first("Quantity")
        }}</span>
      </div>
      <div class="vx-col sm:w-4/12 w-full mt-12">
        <div class="domain-wrapper flex justify-between items-center">
          <label>Payment Type</label>
          <vs-radio class="ml-3" v-model="data_local.FormType" vs-value="Free"
            >Free</vs-radio
          >
          <vs-radio class="ml-3" v-model="data_local.FormType" vs-value="Paid"
            >Paid</vs-radio
          >
        </div>
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-if="data_local.FormType == 'Paid'"
      >
        <label>Price Including Tax?</label>
        <vs-switch v-model="data_local.PriceIncludingTax" />
      </div>
      <div
        class="vx-col sm:w-4/12 w-full mt-4"
        v-if="data_local.FormType == 'Paid'"
      >
        <label>Currency</label>
        <v-select
          :clearable="true"
          name="Currency"
          v-model="data_local.Currency"
          label="cc"
          :options="Currencies"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Currency')">{{
          errors.first("Currency")
        }}</span>
      </div>
      <div
        class="vx-col sm:w-4/12 w-full mt-4"
        v-if="data_local.FormType == 'Paid'"
      >
        <label>Price</label>
        <vs-input-number
          class="w-full"
          name="Price"
          v-model="data_local.Price"
          v-validate="'required' | 'number'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Price')">{{
          errors.first("Price")
        }}</span>
      </div>
      <div
        class="vx-col sm:w-4/12 w-full mt-4"
        v-if="data_local.PriceIncludingTax == false"
      >
        <label>Tax (%)</label>
        <vs-input-number
          class="w-full"
          name="Tax"
          v-model="data_local.Tax"
          v-validate="'required' | 'number'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Price')">{{
          errors.first("Price")
        }}</span>
      </div>
      <div class="vx-col sm:w-1/1 w-full mt-4">
        <label>Description</label>
        <ckeditor
          class="desc-event"
          v-model="data_local.Description"
          :config="editorConfig"
        ></ckeditor>
      </div>
      <div class="vx-col sm:w-1/2 w-full mt-4">
        <label>Advanced Settings</label>
        <vs-switch v-model="data_local.AdvancedSettings" />
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-show="data_local.AdvancedSettings"
      >
        <div class="domain-wrapper flex justify-between items-center">
          <label>Form Fillup Time Expiry (Min)</label>
          <div class="ticket-quantity-wrap">
            <vs-input-number
              class="w-full"
              min="2"
              name="Expiry"
              v-model="data_local.Expiry"
            />
          </div>
        </div>
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-show="data_local.AdvancedSettings"
      >
        <div class="domain-wrapper">
          <vs-input-number
            class="w-full"
            :min="1"
            :max="10"
            label="Min Limit"
            name="MinLimit"
            v-model="data_local.MinLimit"
            v-validate="'required|max_value:10'"
          />
        </div>
        <span class="text-danger text-sm" v-show="errors.has('MinLimit')">{{
          errors.first("MinLimit")
        }}</span>
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-show="data_local.AdvancedSettings"
      >
        <div class="domain-wrapper">
          <vs-input-number
            class="w-full"
            :min="Number(data_local.MinLimit)"
            :max="10"
            label="Max Limit"
            name="MaxLimit"
            v-model="data_local.MaxLimit"
            v-validate="
              `required|max_value:10|min_value:${Number(data_local.MinLimit)}`
            "
          />
        </div>
        <span class="text-danger text-sm" v-show="errors.has('MaxLimit')">{{
          errors.first("MaxLimit")
        }}</span>
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-show="data_local.AdvancedSettings"
      >
        <label>Status</label>
        <!-- <v-select v-model="data_local.Status" :options="['Open','Closed']" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
        <vs-switch v-model="data_local.IsPublished" />
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-show="data_local.AdvancedSettings"
      >
        <label>Visibility</label>
        <!-- <v-select v-model="data_local.Visibility" :options="['Visible','Hidden']" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
        <vs-switch v-model="data_local.Visibility" />
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-show="data_local.AdvancedSettings"
      >
        <label>Sale Start Date</label>
        <div class="domain-wrapper">
          <flat-pickr
            label="Sale StartDate"
            name="SaleStartDate"
            v-model="data_local.SaleStartDate"
            v-validate="'required'"
            :config="configdateTimePickerStart"
            class="time-pkr w-full"
          />
        </div>
        <span
          class="text-danger text-sm"
          v-show="errors.has('SaleStartDate')"
          >{{ errors.first("SaleStartDate") }}</span
        >
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-show="data_local.AdvancedSettings"
      >
        <label>Sale End Date</label>
        <div class="domain-wrapper">
          <flat-pickr
            label="Sale EndDate"
            name="SaleEndDate"
            v-model="data_local.SaleEndDate"
            v-validate="'required'"
            :config="configdateTimePickerEnd"
            class="time-pkr w-full"
          />
        </div>
        <span class="text-danger text-sm" v-show="errors.has('SaleEndDate')">{{
          errors.first("SaleEndDate")
        }}</span>
      </div>
      <div
        class="vx-col sm:w-1/2 w-full mt-4"
        v-if="data_local.FormType == 'Paid'"
      >
        <label>Ticket ID</label>
        <div class="domain-wrapper">
          <vs-input class="w-full mt-4" type="text" v-model="data_local.TicketPriceID" />
        </div>
      </div>
    </div>

    <div class="vx-row button-wrap">
      <!-- <vs-button class="ml-3 mt-2" @click="$router.push('/event/tickets')">Back To List</vs-button> -->
      <div class="vx-col sm:w-2/3 w-full ml-auto">
        <vs-button
          color="warning"
          type="border"
          class="mb-2 mr-3"
          @click="reset_data"
          >Reset</vs-button
        >
        <vs-button class="mb-2" @click="before_save">Submit</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
import moment from "moment-timezone";
import vSelect from "vue-select";
import ls from "@/common/localStorage";

let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");

export default {
  components: {
    flatPickr,
    vSelect,
    ckeditor: CKEditor.component,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      Currencies: [],
      configdateTimePickerStart: {
        minDate: null,
        maxDate: null,
        onChange: (val) => {
          if (val) this.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerEnd: {
        minDate: null,
        maxDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      editorConfig: CKconfig.editorConfig,
    };
  },
  computed: {
    showE2MLive: function () {
      return this.data_local.CustomDomain.indexOf(".") == -1;
    },
  },
  watch: {},
  methods: {
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    save_changes() {
      this.$vs.loading();
      let RegistrationTypeId = this.data_local.RegistrationTypeId
        ? this.data_local.RegistrationTypeId
        : null;
      this.data_local.StartDate = this.GetTimeByZone(
        this.data_local.SaleStartDate,
        Session_Event_TZ
      );
      this.data_local.EndDate = this.GetTimeByZone(
        this.data_local.SaleEndDate,
        Session_Event_TZ
      );
      if (RegistrationTypeId) {
        this.$store
          .dispatch("TicketManagement/updateRegistrationType", {
            RegistrationTypeId: RegistrationTypeId,
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              title: "Ticket",
              text: res.message,
            });
            this.$vs.loading.close();
            this.$emit("reloadGrid");
          });
      } else {
        this.$store
          .dispatch("TicketManagement/addRegistrationType", {
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              title: "Ticket",
              text: res.message,
            });
            this.$vs.loading.close();
            this.$emit("reloadGrid");
          });
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
  },
  mounted() {
    this.$store.dispatch("TicketManagement/getCurrencies").then((res) => {
      this.Currencies = res;
    });
  },
};
</script>